import React, { useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import useForm from "../../../components/controls/useForm";
import Loading from "../../../components/Ui/Loading";
import {
  useAddQuizMutation,
  useEditQuizMutation,
  useGetQuizQuery,
} from "../../../features/Admin/Quizzes/quizzesApi";
import { useGetVideosQuery } from "../../../features/Admin/Videos/videosApi";
import Error from "../../../components/Ui/Error";
import FormField from "./FormField";

const initializeValues = {
  question: "",
  video_id: "",
  video_title: "",
  optionOne: "",
  isCorrectOptionOne: false,
  optionTwo: "",
  isCorrectOptionTwo: false,
  optionThree: "",
  isCorrectOptionThree: false,
  optionFour: "",
  isCorrectOptionFour: false,
};
export default function QuizzesForm({ isAddForm }) {
  // *****************************************************DECLARATION START******************************************************************************
  const { quizId } = useParams();
  const navigate = useNavigate();

  // REDUX API/SLICE START
  const { data: videos } = useGetVideosQuery();
  const {
    data: quiz,
    isLoading: singleQuizIsLoading,
    isSuccess: singleQuizIsSuccess,
    isError: singleQuizIsError,
  } = useGetQuizQuery(quizId, { skip: isAddForm }); // Get Single Quiz
  const [
    addQuiz,
    {
      isLoading: addQuizIsLoading,
      isSuccess: addQuizIsSuccess,
      isError: addQuizIsError,
    },
  ] = useAddQuizMutation(); // Added new Quiz
  const [
    editQuiz,
    {
      isLoading: editQuizIsLoading,
      isSuccess: editQuizIsSuccess,
      isError: editQuizIsError,
    },
  ] = useEditQuizMutation(); // Edit Quiz
  // REDUX API/SLICE END

  const { values, setValues, handleInputChange, resetForm } =
    useForm(initializeValues);
  // *****************************************************DECLARATION END******************************************************************************
  // *****************************************************useEffect START******************************************************************************
  useEffect(() => {
    if (addQuizIsSuccess || editQuizIsSuccess) {
      resetForm(initializeValues);
      navigate("/admin/quizzes");
    }
  }, [addQuizIsSuccess, editQuizIsSuccess, navigate]); // Only for Add and edit Form
  useEffect(() => {
    if (singleQuizIsSuccess) {
      const options = quiz.options;
      setValues({
        ...quiz,
        optionOne: options[0].option,
        isCorrectOptionOne: options[0].isCorrect,
        optionTwo: options[1].option,
        isCorrectOptionTwo: options[1].isCorrect,
        optionThree: options[2].option,
        isCorrectOptionThree: options[2].isCorrect,
        optionFour: options[3].option,
        isCorrectOptionFour: options[3].isCorrect,
      });
    }
  }, [singleQuizIsSuccess]);

  // *****************************************************useEffect END******************************************************************************
  // *****************************************************HANDLE START******************************************************************************
  const handleCancel = () => {
    navigate("/admin/quizzes");
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    const video = videos.find((v) => v.id == values.video_id);
    const expectedValues = {
      question: values.question,
      video_id: values.video_id,
      video_title: video?.title,
      options: [
        {
          option: values.optionOne,
          isCorrect: values.isCorrectOptionOne,
        },
        {
          option: values.optionTwo,
          isCorrect: values.isCorrectOptionTwo,
        },
        {
          option: values.optionThree,
          isCorrect: values.isCorrectOptionThree,
        },
        {
          option: values.optionFour,
          isCorrect: values.isCorrectOptionFour,
        },
      ],
    };
    isAddForm
      ? addQuiz(expectedValues)
      : editQuiz({
          data: { ...expectedValues },
          id: quizId,
        });
  };
  // *****************************************************HANDLE END******************************************************************************
  // *****************************************************Decided which part render START******************************************************************************
  const formContent =
    addQuizIsLoading || editQuizIsLoading || singleQuizIsLoading ? (
      <Loading />
    ) : (!addQuizIsLoading || !editQuizIsLoading) &&
      (addQuizIsError || editQuizIsError || singleQuizIsError) ? (
      <Error
        header={"System Error !!"}
        message={"Please contract with administrator"}
      />
    ) : (
      <FormField
        isAddForm={isAddForm}
        videos={videos}
        values={values}
        handleSubmit={handleSubmit}
        handleInputChange={handleInputChange}
        handleCancel={handleCancel}
      />
    );
  // *****************************************************Decided which part render END******************************************************************************

  return (
    <>
      <div className="lg:pl-[14rem] mt-[5.8125rem]">
        <main className="max-w-3xl rounded-lg mx-auto relative z-20 p-10 xl:max-w-none bg-[#1E293B]">
          <h1 className="mb-10 text-center lws-section-title">
            {isAddForm ? "Add New Quiz" : "Edit Quiz"}
          </h1>
          <div className="max-w-3xl mx-auto">{formContent}</div>
        </main>
      </div>
    </>
  );
}
